import moment from 'moment';
import util from '@core/services/util';
import filters from '@core/services/filters';

const { prettyNumber } = filters;

export default class FIMenuVehicleWarrantyCoverage {
	constructor(init) {
		if (init) {
			this.months = init.months;
			this.miles = init.miles;
		} else {
			this.months = null;
			this.miles = null;
		}
	}

	milesLeft(vehicleMiles) {
		let retVal = null;
		if (this.miles && (vehicleMiles || vehicleMiles === 0)) {
			retVal = this.miles - vehicleMiles;
		}
		return retVal;
	}

	monthsLeft(warrantyStartDate) {
		if (this.months && warrantyStartDate) {
			return util.toMoment(warrantyStartDate).add(this.months, 'month').diff(moment(), 'months', true);
		} else {
			return null;
		}
	}

	monthsDisplay(inventoryType, warrantyStartDate) {
		//console.log('monthsDisplay', inventoryType, warrantyStartDate, this.months);
		if (inventoryType) {
			if (inventoryType.toLowerCase() == 'new' && this.months) return prettyNumber(this.months, 0);
			else if (this.monthsLeft(warrantyStartDate)) return prettyNumber(this.monthsLeft(warrantyStartDate), 0);
			else return '';
		} else return '';
	}

	milesDisplay(inventoryType, vehicleMiles) {
		//console.log('milesDisplay', inventoryType, vehicleMiles, this.miles);
		if (inventoryType) {
			if (inventoryType.toLowerCase() == 'new' && this.miles) return prettyNumber(this.miles, 0);
			else if (this.milesLeft(vehicleMiles)) return prettyNumber(this.milesLeft(vehicleMiles), 0);
			else return '';
		} else return '';
	}

	valid(vehicleMiles, warrantyStartDate) {
		let valid = false;
		let overMiles = false;
		let overTerm = false;

		if (this.miles || this.months) {
			valid = true;

			if (vehicleMiles > this.miles) overMiles = true;

			if (this.months) overTerm = moment() > util.toMoment(warrantyStartDate).add(this.months, 'month');

			if (overMiles || overTerm) valid = false;
		}

		return valid;
	}
}
